import { merge } from 'lodash';
import { bigQuery } from '@fiverr-private/obs';

const DATA = {
    group: 'user_action',
    sub_group: 'tailored_home_page',
    event_source: 'tailored_home_page',
    page: {
        element: {
            name: 'JTBD_seamless_migration',
        },
        component: {
            name: 'job_to_be_done',
        },
    },
};

export const track = {
    impression: (biEnrichment = {}) => {
        const payload = merge(
            DATA,
            {
                action: {
                    type: 'imp',
                },
                type: 'tailored_home_page_impression',
                page: {
                    element: {
                        type: 'pro entry',
                    },
                },
            },
            biEnrichment
        );

        bigQuery.send(payload);
    },
    click: (biEnrichment = {}) => {
        const payload = merge(
            DATA,
            {
                action: {
                    type: 'click',
                },
                type: 'clicked_on_tailored_home_page_component',
                page: {
                    element: {
                        type: 'button',
                    },
                },
            },
            biEnrichment
        );

        bigQuery.send(payload);
    },
};
